import { render, staticRenderFns } from "./T&CandGDPRStatement.vue?vue&type=template&id=5ac6fe23"
import script from "./T&CandGDPRStatement.vue?vue&type=script&lang=js"
export * from "./T&CandGDPRStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports